import { Currency } from "@redotech/money/currencies";
import { MetricDefinitionPartZodSchema } from "@redotech/redo-conversion-core-common/checkouts/metric-definition";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getCheckoutOptimizationSummaryMetrics = {
  name: "getCheckoutOptimizationSummaryMetrics" as const,
  input: z.null(),
  output: z.object({
    annualizedCumulativeImpactToRevenuePerCheckoutFromAbTestsLastYear: z.object(
      {
        shopCurrency: createEnum(Currency),
        value: z.number().optional(),
        calculationUsed: z.array(MetricDefinitionPartZodSchema).optional(),
      },
    ),
    checkoutConversionRate: z.number().optional(),
    averageShippingRevenuePerOrder: z.object({
      shopCurrency: createEnum(Currency),
      value: z.number().optional(),
    }),
    analyzedPeriod: z.object({ startDate: z.string(), endDate: z.string() }),
  }),
};
